module.exports = __webpack_public_path__ + "src/assets/games/55/bj2.png";